module.exports = __webpack_public_path__ + "static/AgSmallLogo-e9881f2da63513410b6d5368acf84eaa.png";